import { NgModule } from '@angular/core';
import { OrdinalPipe } from './ordinal.pipe';

@NgModule({
    declarations: [OrdinalPipe],
    exports: [OrdinalPipe],
})
export class OrdinalModule {}
